import { styled, Chip, chipClasses } from '@mui/material';

export const ComminSoonBadgeRoot = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(9),
  height: 16,
  textTransform: 'uppercase',
  fontWeight: theme.typography.fontWeightBold,
  marginLeft: theme.spacing(1),

  [`& .${chipClasses.label}`]: {
    padding: theme.spacing(0, 0.5),
  },
}));
